import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faCheck, faRedo } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import ClientSmsModal from "app/companion/pages/delivery/ClientSmsModal";
import {
  canSendClientSms,
  canResendClientSms,
} from "app/companion/pages/delivery/clientSms";

/**
 * Envoi manuel du SMS d'annonce, depuis la feuille de livraison de l'arrêt affiché.
 *
 * Deux usages : la première livraison de la tournée, qu'aucune confirmation ne précède,
 * et le renvoi — client qui dit n'avoir rien reçu, créneau qui a bougé. C'est le seul
 * chemin qui autorise un second envoi : le popup automatique reste en un coup.
 */
const ClientSmsButton = ({ delivery }) => {
  const [show, setShow] = useState(false);

  if (!delivery || !canResendClientSms(delivery)) return null;

  const sentAt = delivery.client_sms_sent_at;
  const sentCount = delivery.client_sms_count || 0;
  const isFirstSend = canSendClientSms(delivery);

  // Bloc à part entière : sans ça le bouton se colle à la valeur de NUMERO UTILE,
  // qui est du texte inline.
  return (
    <div>
      {sentAt && (
        <div className="mt-2 text-success">
          <FontAwesomeIcon icon={faCheck} />{" "}
          <small>
            Client prévenu par SMS le {moment(sentAt).format("DD/MM")} à{" "}
            {moment(sentAt).format("HH[h]mm")}
            {sentCount > 1 && ` (${sentCount} envois)`}
          </small>
        </div>
      )}

      <Button
        variant={isFirstSend ? "outline-primary" : "outline-secondary"}
        size="sm"
        className="mt-2"
        onClick={() => setShow(true)}
      >
        {isFirstSend ? (
          <>
            <FontAwesomeIcon icon={faCommentDots} /> Prévenir le client du départ
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={faRedo} /> Renvoyer le SMS
          </>
        )}
      </Button>

      <ClientSmsModal
        show={show}
        onClose={() => setShow(false)}
        roadmapDelivery={delivery}
        resend
      />
    </div>
  );
};

export default ClientSmsButton;
